/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';

export default class StandaloneProcedurePreviewIndexRoute extends Route {
  templateName = 'apps/app/automation/fin-ai-agent/procedures/procedure/preview/index';
}
